'use strict'
import _ from 'lodash'
import magazzinoService from '@/services/magazzinoService.js'
import movimentiService from '@/services/movimentiService.js'
import prodottiService from '@/services/prodottiService.js'
import configurazioni from '@/services/configurazioniService.js'
import etichetteService from '@/services/etichetteService.js'

const autoconsumo = async function(righeCarrello, magazzinoMovimenti, operatore) {
  const causali = await configurazioni.getConfigurazione('magazzino_causali', 'causali')
  const causale = causali.find(el => el.codice === 'autoconsumo')
  const base = {
    magazzino: magazzinoMovimenti || 'mag01',
    tipoCausale: causale.tipo,
    causale: causale.codice,
    data: new Date(),
    riferimento: 'autoconsumo',
    mostraCliente: causale.visualizzaCliente,
    mostraFornitore: causale.visualizzaFornitore,
    tipoPrezzo: causale.tipoPrezzo,
    operatore: operatore
  }
  const movimentiMultipli = await buildMovimentiMultipli(righeCarrello, base)
  await magazzinoService.creaMovimentiMultipli(movimentiMultipli)
}

const generica = async function(righeCarrello, causaleMovimento, riferimento, data, operatore) {
  const causali = await configurazioni.getConfigurazione('magazzino_causali', 'causali')
  const causale = causali.find(el => el.codice === causaleMovimento)
  const base = {
    magazzino: 'mag01',
    tipoCausale: causale.tipo,
    causale: causale.codice,
    data: data || new Date(),
    riferimento: riferimento || causaleMovimento,
    mostraCliente: causale.visualizzaCliente,
    mostraFornitore: causale.visualizzaFornitore,
    tipoPrezzo: causale.tipoPrezzo
  }
  if (operatore && operatore.codice) {
    base.operatore = operatore
  }
  const movimentiMultipli = await buildMovimentiMultipli(righeCarrello, base)
  await magazzinoService.creaMovimentiMultipli(movimentiMultipli)
}

const pc = async function(righeCarrello) {
  const base = {
    magazzino: 'pc',
    tipoCausale: 'vendita',
    causale: 'pc',
    data: new Date(),
    riferimento: 'pc',
    mostraCliente: false,
    mostraFornitore: false,
    tipoPrezzo: 'vendita'
  }
  const movimentiMultipli = await buildMovimentiMultipli(righeCarrello, base)
  await magazzinoService.creaMovimentiMultipli(movimentiMultipli, true)
}

const usaSelezione = async function(righeCarrello, base) {
  const movimentiMultipli = await buildMovimentiMultipli(righeCarrello, base)
  await magazzinoService.creaMovimentiMultipli(movimentiMultipli)
}

/* const buildMovimentiMultipli_old = async function(righeCarrello, base) {
  debugger
  const prodottiInseriti = righeCarrello
  const ids = prodottiInseriti.map(x => x.codice)
  var prodotti = await prodottiService.getProdottiByIds(ids)
  const movimenti = prodotti.map(el => {
    const quantita = prodottiInseriti.find(x => x.codice === el._id).quantita
    const nM = {
      magazzino: base.magazzino,
      tipo: base.tipoCausale,
      causale: base.causale,
      data: base.data,
      prodotto: {
        codice: el._id,
        um: _.get(el, 'magazzino.unitaMisura', '') || 'n'
      },
      anagrafica: {},
      riferimento: {
        tipo: 'usaSelezione',
        id: base.riferimento,
        data: base.data
      }
    }
    if (base.mostraCliente && base.nominativo) {
      nM.anagrafica.cliente = {
        codice: base.nominativo,
        descrizione: base.nominativoDescrizione
      }
    }
    if (base.mostraFornitore && base.nominativo) {
      nM.anagrafica.fornitore = {
        codice: base.nominativo,
        descrizione: base.nominativoDescrizione
      }
    }

    nM.quantita = +parseFloat(quantita).toFixed(2)
    if (base.tipoPrezzo === 'acquisto') {
      nM.valore = +parseFloat(_.get(el, 'magazzino.prezzoAcquisto', 0)).toFixed(2)
    } else {
      nM.valore = +parseFloat(_.get(el, 'prezzo.L1.base', 0)).toFixed(2)
    }

    return nM
  })
  return movimenti
} */

const buildMovimentiMultipli = async function(righeCarrello, base) {
  let prodottiInseriti = righeCarrello
  prodottiInseriti = prodottiInseriti.filter(x => x.tipo !== 'descrizione')
  const ids = prodottiInseriti.map(x => x.codice)
  var prodotti = await prodottiService.getProdottiByIds(ids)

  const movimenti = prodottiInseriti.map(el => {
    const quantita = el.quantita
    const prodotto = prodotti.find(x => x._id === el.codice)
    if (prodotto) {
      const nM = {
        magazzino: base.magazzino,
        tipo: base.tipoCausale,
        causale: base.causale,
        data: base.data,
        prodotto: {
          codice: prodotto._id,
          um: _.get(prodotto, 'magazzino.unitaMisura', '') || 'n'
        },
        anagrafica: {},
        riferimento: {
          tipo: 'usaSelezione',
          id: base.riferimento,
          data: base.data
        }
      }
      if (base.operatore) {
        nM.riferimento.operatore = base.operatore
      }
      if (base.mostraCliente && base.nominativo) {
        nM.anagrafica.cliente = {
          codice: base.nominativo,
          descrizione: base.nominativoDescrizione
        }
      }
      if (base.mostraFornitore && base.nominativo) {
        nM.anagrafica.fornitore = {
          codice: base.nominativo,
          descrizione: base.nominativoDescrizione
        }
      }
      nM.quantita = +parseFloat(quantita).toFixed(2)
      if (base.tipoPrezzo === 'acquisto') {
        nM.valore = +(parseFloat(_.get(prodotto, 'magazzino.prezzoAcquisto', 0) || 0) * nM.quantita).toFixed(2)
      } else {
        nM.valore = +((parseFloat(el.prezzoUnitario) || parseFloat(_.get(prodotto, 'prezzo.L1.base', 0))) * nM.quantita).toFixed(2)
      }
      return nM
    }
  })
  return movimenti
}

const verificaAggiungiMovimenti = async function(documento, righe) {
  // const movimentiSalvati = await movimenti.getMovimentiPerRiferimento('documento', documento._id)
  // Verificare altri tipi di documento
  // const prodotti = documento.righe.filter(x => x.prodotto && x.prodotto.codice)
// prendere dalle righe
  const modello = await movimentiService.getModello('xxx')
  let numErrori = 0
  for (const p of righe) { // I movimenti vengono creati solo per le righe dove è presente la quantità.
  // for (const p of prodotti) {
    const prodotto = await prodottiService.getProdotto(p.codice)
    const movimento = JSON.parse(JSON.stringify(modello))

    movimento.data = new Date() // TODO: Verificare se data operazione o data documento
    movimento.magazzino = documento.magazzino || 'mag01' // TODO: Magazzino didefault da impostazioni

    movimento.prodotto = {
      codice: p.codice,
      lotti: [],
      um: _.get(prodotto, 'magazzino.unitaMisuraVendita', '') || _.get(prodotto, 'magazzino.unitaMisura', ''),
      quantita: +parseFloat(p.quantita).toFixed(2) // qtaVendita
    }
    movimento.quantita = +parseFloat(p.quantita).toFixed(2) // qtaVendita
    // const pzUn = +parseFloat((p.ordine && p.ordine.prezzoUnitario) || p.valore.acquisto).toFixed(2) // Verificare eventuali sconti
    const pzUn = +parseFloat(p.prezzoAcquisto).toFixed(2) || +parseFloat(_.get(prodotto, 'magazzino.prezzoAcquistoPezzo', 0)).toFixed(2) // Verificare eventuali sconti
    movimento.valore = +parseFloat(movimento.quantita * pzUn).toFixed(2) // qtaAnagrafica
    movimento.causale = documento.tipoDocumento.causale
    movimento.anagrafica = {
      cliente: '',
      fornitore: documento.anagrafica.fornitore
    }
    movimento.riferimento = {
      tipo: 'documento',
      id: documento.codice,
      data: documento.data,
      riga: p.rigaCodice
    }
    if (!await magazzinoService.creaMovimenti(movimento)) {
      numErrori++
    }
  }
  return numErrori
}

const stampaEtichette = async function(prodottiInseriti) {
  try {
    const ids = prodottiInseriti.map(x => x.codice)
    var prodotti = await prodottiService.getProdottiByIds(ids)
    const etichette = prodotti.map(el => {
      const quantita = prodottiInseriti.find(x => x.codice === el._id).quantita
      return {
        codice: el.codice,
        descrizione: el.descrizione,
        taglia: el.varianti && el.varianti.variante1 && el.varianti.variante1.descrizione ? el.varianti.variante1.descrizione : '',
        colore: el.varianti && el.varianti.variante2 && el.varianti.variante2.descrizione ? el.varianti.variante2.descrizione : '',
        prezzo: el.prezzo && el.prezzo.L1 && el.prezzo.L1.base ? el.prezzo.L1.base : '',
        barcode: el.ricercaBarcode,
        prezzo2: el.prezzo && el.prezzo.L2 && el.prezzo.L2.base ? el.prezzo.L2.base : '',
        prezzo2Sconto: el.prezzo && el.prezzo.L2 && el.prezzo.L2.sconto ? el.prezzo.L2.sconto : '',
        acquisto: el.ultimoAcquisto && el.ultimoAcquisto.prezzo ? el.ultimoAcquisto.prezzo : el.magazzino && el.magazzino.prezzoAcquisto ? el.magazzino.prezzoAcquisto : '',
        quantita: quantita || 1
      }
    })
    const str = JSON.stringify(etichette)
    const impostazioni = await configurazioni.getConfigurazione('display_generale')
    const tipoStampa = impostazioni.etichette.tipo
    const report = impostazioni.etichette.report
    await etichetteService.stampaEtichetta(tipoStampa, report, str, 0, 'movimento') // salta impostato = 0
  } catch {
  }
}

const calcolaGiacenza = function (prodotto, magazziniMultipli, magazzinoSelezionato) {
  let giacenza = prodotto.magazzino.giacenza || 0
  if (magazziniMultipli) {
    const giacenzaParziale = _.get(prodotto, 'magazzino.giacenzaParziale', null)
    if (typeof giacenzaParziale === 'object' && !_.isEmpty(giacenzaParziale)) {
      const gg = giacenzaParziale[magazzinoSelezionato] || {}
      giacenza = gg.giacenza || 0
    }
  }
  return +parseFloat(giacenza).toFixed(2)
}

const rettificaGiacenza = async function(righeCarrello, magazzinoSelezionato) {
  const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
  const magazziniMultipli = _.get(impostazioni, 'magazzino.magazziniMultipli', false)

  for (const r of righeCarrello) {
    const prodotto = await prodottiService.getProdotto(r.codice)
    const valore = r.quantita
    const giac = calcolaGiacenza(prodotto, magazziniMultipli)
    const delta = +(valore - giac).toFixed(2)
    const rettifica = {
      idProdotto: prodotto._id,
      delta: delta,
      valore: valore,
      tipoMovimento: 'rettifica',
      magazzino: magazzinoSelezionato
    }
    await magazzinoService.creaMovimentoRettificaGiacenza(rettifica)
    prodotto.magazzino.giacenzaParziale = prodotto.magazzino.giacenzaParziale || {}
    const mg = prodotto.magazzino.giacenzaParziale
    mg[rettifica.magazzino] = mg[rettifica.magazzino] || {}
    mg[rettifica.magazzino].giacenza = +valore.toFixed(2)
    mg[rettifica.magazzino].valore = +(mg[rettifica.magazzino].giacenza * (prodotto.magazzino.prezzoAcquisto || 0)).toFixed(2)
    let totG = 0
    let totV = 0
    for (const gg of Object.keys(mg)) {
      totG += mg[gg].giacenza
      totV += mg[gg].valore
    }
    prodotto.magazzino.giacenza = +totG.toFixed(2)
    prodotto.magazzino.valore = +totV.toFixed(2)
    await prodottiService.aggiornaProdotto(prodotto)
  }
}

// Duplicate con dashboardMachine per comodità ... eventualmente spostare
function fnGetOperatore(context) {
  let op = ''
  if (context.operatore.servizio) {
    op = context.operatore.servizio.codice || ''
  }
  if (!op && context.operatore.accesso) {
    op = context.operatore.accesso.codice || ''
  }
  return op
}

function fnGetNomeOperatore(context, tipoInfo) {
  let op = ''
  if (context.operatore.servizio) {
    op = tipoInfo === 'descrizione' ? context.operatore.servizio.nome || '' : context.operatore.servizio.codice || ''
  }
  if (!op && context.operatore.accesso) {
    op = tipoInfo === 'descrizione' ? context.operatore.accesso.nome || '' : context.operatore.accesso.codice || ''
  }
  return op
}

export default {
  autoconsumo,
  generica,
  pc,
  usaSelezione,
  verificaAggiungiMovimenti,
  stampaEtichette,
  rettificaGiacenza,
  fnGetOperatore,
  fnGetNomeOperatore
}
